module.exports = __webpack_public_path__ + "00976d98a249c4c21fedced97a9389a9.pdf";